export class FiltreItem {
  field: string;
  value: any;
  displayName: string;

  constructor(field: string, displayName: string, value: any) {
    this.field = field;
    this.displayName = displayName;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/components/vos-filtres/filtre-item.ts